import { View } from "binder"
import { CashPaymentViewModel } from "./cashPayment-viewModel"

export class CashPaymentView extends View<CashPaymentViewModel>{
    GetViewUniqueId(): string {
        return "V-90FD632C-BBEB-4855-BA36-AE69F4CDB228"
    }
    loadHtml(): string {
        let element = require('./cashPayment.html').default;
        let style = require('./cashPayment.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    public set maxAmount(v: number) { this._maxAmount = v; } public get maxAmount(): number { return this._maxAmount;} private _maxAmount: number;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set invoiceId(v: string) { this._invoiceId = v; } public get invoiceId(): string { return this._invoiceId;} private _invoiceId: string;
    public set isAmountInvalid(v: boolean) { this._isAmountInvalid = v; } public get isAmountInvalid(): boolean { return this._isAmountInvalid;} private _isAmountInvalid: boolean;
    
}
